// extracted by mini-css-extract-plugin
export default {"slider":"Ranking_slider__70VvB","tarjetas":"Ranking_tarjetas__WWV5Y"};